import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import {State} from "@/types/Workflow";
import Instance from "@/types/Instance";
import {Component} from "vue-facing-decorator";
import IdeaProperty from "@/types/IdeaProperty";
import {InstanceContext} from "@/types/InstanceContext";
import {instanceRoute, opensByItself, resolveInstanceHref} from "@/utils/instanceLink";
import {markOrigin} from "@/utils/motion";

@Component
class IdeaLevelRouteComponent extends WorkspaceRouteComponent {

    /**
     * De onde sai o alias da idea. Sobrescreva em componentes que não são
     * dirigidos pela URL (modais). Nunca chame super.ideaAlias numa sobrescrita:
     * isso alcança o getter cru do protótipo e fura o cache de computed do Vue.
     */
    get ideaAlias(): string {
        return this.params.idea
    }

    get idea() {
        return this.workspace.ideaWith(this.ideaAlias)!
    }

    get workflow() {
        return this.workspace.workflowOf(this.idea)
    }

    async updateCurrentIdea(changes: any) {
        return await this.updateIdea(this.idea, changes)
    }

    async deleteCurrentIdea() {
        return await this.deleteIdea(this.idea)
    }

    async deletePropertyFromCurrentIdea(property: IdeaProperty) {
        return await this.deletePropertyFromIdea(this.idea, property)
    }

    /** A regra de "sem situação é a inicial" mora no fluxo; aqui só se pergunta a ele. */
    currentStateOf(instance: Instance): State | undefined {
        return this.workflow ? this.workflow.currentStateOf(instance) : undefined
    }

    /** URL real da página da instância, para o href dos links. */
    instanceHref(context: InstanceContext): string {
        return resolveInstanceHref(this.$router, context)
    }

    /**
     * Clique num link de instância. O stopPropagation vem ANTES da checagem de
     * modificadores de propósito: sem isso, um ctrl+clique num link dentro de
     * linha clicável abriria a aba nova E dispararia o handler da linha.
     * Com modificador ou botão do meio, deixa o browser abrir a página inteira.
     */
    onInstanceLink(e: MouseEvent, context: InstanceContext) {
        e.stopPropagation()
        if (opensByItself(e)) return
        e.preventDefault()
        //Se o host abrir a ficha em janela, ela nasce do card ou do link clicado
        markOrigin(e.currentTarget)
        this.openInstance(context)
    }

    /** Padrão: navega. Hosts que abrem modal sobrescrevem. */
    openInstance(context: InstanceContext) {
        this.$router.push(instanceRoute(context)).catch(() => undefined)
    }
}

export default IdeaLevelRouteComponent


